module.exports = __webpack_public_path__ + "media/src/images/demo_top-70fecc04e063e498239f53eab084773a.jpg";